

<div class="rate-agreement-container body-content-area">
    <div class="action-area" style="margin: 20px;">
        <div  style="text-align: center;width: 95%;">
          <div style="font-size: 20px;text-transform: uppercase;font-weight: 600;margin-top: 20px;padding: 20px;"> No Application Access</div> 
            
        </div>
        <div  style="text-align: center;width: 95%;font-size: 16px; font-weight: 500;padding: 10px;">
            Please Reach out to Admin for Access Request. 
        </div>
        <p>or Raise a request here  </p>
        <p><a href="mailto:support@dhlllpford.freshdesk.com">support&#64;dhlllpford.freshdesk.com</a></p>
        <!-- <p><a href="https://dsc-um.dhl.com/um/#/" target="_blank">Request Access</a> </p> -->
    </div>
</div>